import React from 'react';

import { IIconProps, TIconType } from '../interface';

const KpiOutlineIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M20.25 20.25H3.75'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M13.5 7.5V16.5C13.5 16.9142 13.8358 17.25 14.25 17.25H18C18.4142 17.25 18.75 16.9142 18.75 16.5V7.5C18.75 7.08579 18.4142 6.75 18 6.75H14.25C13.8358 6.75 13.5 7.08579 13.5 7.5Z'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.75 3H6C5.58579 3 5.25 3.33579 5.25 3.75V16.5C5.25 16.9142 5.58579 17.25 6 17.25H9.75C10.1642 17.25 10.5 16.9142 10.5 16.5V3.75C10.5 3.33579 10.1642 3 9.75 3Z'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default KpiOutlineIcon;
